export const runUpdater = async (allData, data, columns, prop, value, id) => {
  if (prop === 'type') {
    const optionsValue = columns
      .find((c) => c.accessor === 'type')
      .options.find((t) => t.id === value);

    allData[id]['type'] = optionsValue ? optionsValue.id : value;
  }

  if (prop === 'referralStatus') {
    const optionsValue = columns
      .find((c) => c.accessor === 'referralStatus')
      .options.find((t) => t.id === value);

    allData[id]['referralStatus'] = optionsValue?.id || value;
  }

  if (prop === 'doctor') {
    const optionsValue = columns
      .find((c) => c.accessor === 'doctor')
      .options.find((t) => t.id === value);

    allData[id]['doctor'] = optionsValue;
  }

  return allData;
};
